export default function (state, val) {
    let filter = state.filters.filter(i => {
        return i.id === val.id;
    })[0];
    for (let k in val) {
        switch (k) {
            case 'CategoryId':
                filter.CategoryId = val[k];
                filter.PaymentTypeId = '';
                filter.CashList = [];
                filter.PaymentAccountList = [];
                break;
            case 'Contragent':
                let type = '';
                switch (val[k].type) {
                    case 'client':
                        type = 1;
                        break;
                    case 'partner':
                        type = 2;
                        break;
                    case 'partnerLegal':
                        type = 3;
                        break;
                }
                filter.ContragentID = val[k].value ? val[k].value : '';
                filter.ContragentName = val[k].label ? val[k].label : '';
                filter.ContragentSearchTypeId = type;
                break;
            default:
                if (typeof filter[k] !== 'undefined') filter[k] = val[k];
        }
    }
}
